import DETERIORATION_AND_MAINTENANCE from '../../../../../config/simm/shafts/deterioration_and_maintenance.yml';

export const DEFAULT_RATINGS = [0, 1, 2, 3, 4, 5];

function extract(elements, key) {
  return Object.entries(elements)
    .map(([type, element]) => [type, element[key]])
    .reduce((a, [k, v]) => ({ ...a, [k]: v }), {});
}

export const SHAFT_DETERIORATION_MECHANISMS = extract(DETERIORATION_AND_MAINTENANCE.shafts, 'deterioration_mechanisms');
export const STATION_DETERIORATION_MECHANISMS = extract(DETERIORATION_AND_MAINTENANCE.stations, 'deterioration_mechanisms');

export const SHAFT_MAINTENANCE_ACTIONS = extract(DETERIORATION_AND_MAINTENANCE.shafts, 'maintenance_actions');
export const STATION_MAINTENANCE_ACTIONS = extract(DETERIORATION_AND_MAINTENANCE.stations, 'maintenance_actions');
